import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.401 24a.497.497 0 0 1-.331-.125L5.495 12.748a1.002 1.002 0 0 1-.001-1.496L18.069.125a.502.502 0 0 1 .707.044.5.5 0 0 1-.043.705L6.157 12l12.575 11.125a.501.501 0 0 1-.331.875z"
});

var SvgArrowLeft1 = function SvgArrowLeft1() {
  return _ref;
};

export default SvgArrowLeft1;